import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiPlay, FiHelpCircle, FiDownload, FiUsers, FiArrowRight } = FiIcons;

const ProgramDetails = () => {
  const features = [
    { icon: FiCalendar, text: "+21 días", description: "de contenido terapéutico y transformador" },
    { icon: FiPlay, text: "+30 lecciones", description: "en video con el Dr. Llánez y el Dr. Alba" },
    { icon: FiHelpCircle, text: "Preguntas", description: "de reflexión para acompañar el proceso" },
    { icon: FiDownload, text: "Guías", description: "y descargables" },
    { icon: FiUsers, text: "Comunidad", description: "de apoyo 24/7" }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12">
            Invierte en tu Bienestar: Detalles del Programa ESTRATEGIA M.E.T.A.
          </h2>
          
          <div className="space-y-6 mb-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-lg"
              >
                <div className="bg-blue-600 p-3 rounded-full flex-shrink-0">
                  <SafeIcon icon={feature.icon} className="text-white text-xl" />
                </div>
                <div className="text-left">
                  <span className="font-bold text-gray-800 text-lg">{feature.text}</span>
                  <span className="text-gray-600 ml-2">{feature.description}</span>
                </div>
              </motion.div>
            ))}
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-700 transition-colors flex items-center gap-2 mx-auto shadow-lg"
          >
            ¡Inscríbete ahora y asegura tu cupo!
            <SafeIcon icon={FiArrowRight} className="text-xl" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default ProgramDetails;